import { mount, unmount } from 'svelte'
import UserMenu from './UserMenu.svelte'
import type { UserMenuData } from './types'

export function mountUserMenu(element: HTMLElement, data: UserMenuData): () => void {
  element.replaceChildren()
  const app = mount(UserMenu, { target: element, props: data })

  return () => {
    void unmount(app)
  }
}
